import { Brand } from './Brand';
import { Type } from './Type';
import { Environment } from './Environment';
export function getTenant(brand, type, environment) {
    if (type === Type.Team) {
        // lendi-team cause we were too pushed for time to delete the old tenants and create new
        // tenants when we found that team members aren't split by brand
        return "lendi-team-".concat(environment, ".au.auth0.com");
    }
    if (brand === Brand.Domain) {
        return "dlf-".concat(type, "-").concat(environment, ".au.auth0.com");
    }
    if (type === Type.Customer && brand === Brand.Lendi) {
        switch (environment) {
            case Environment.Development:
                return "lala.lendi-dev.net";
            case Environment.Staging:
                return "lala.lendi-stg.net";
            case Environment.Preproduction:
                return "lala.lendi-preprod.net";
            case Environment.Production:
                return "lala.lendi.com.au";
        }
    }
    if (type === Type.Customer && brand === Brand.Aussie) {
        switch (environment) {
            case Environment.Development:
                return "lala.aussie-dev.com.au";
            case Environment.Staging:
                return "lala.aussie-stg.com.au";
            case Environment.Preproduction:
                return "lala.aussie-preprod.com.au";
            case Environment.Production:
                return "lala.aussie.com.au";
        }
    }
    return "".concat(brand, "-").concat(type, "-").concat(environment, ".au.auth0.com");
}
//# sourceMappingURL=getTenant.js.map